<template>
  <div class="Landing-background">
    <Banner :eId="eId" :shopUuid="shopUuid" />
    <div class="pa-5">
      <CreateAppointment :eId="eId" :origin="origin" :shopUuid="shopUuid" landing />
    </div>
  </div>
</template>

<script>
import Banner from '@/components/customer/UI/LandingBanner'
import CreateAppointment from '@/components/customer/CreateAppointment.old'

export default {
  components: {
    Banner,
    CreateAppointment
  },
  props: {
    eId: {
      type: String,
      required: false
    },
    origin: {
      default: null,
      required: false,
      type: String
    },
    shopUuid: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped lang="scss">
.Landing-background {
  min-height: 100vh;
  background-color: #e4e8ec;
}
</style>